
import { SharedModule } from './shared/shared.module';
import { RequestHandlerInterceptor } from './shared/interceptors/RequestHandlerInterceptor';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { CategoryComponent } from './cataloge/category/category/category.component';
import { ChangeLogTemplateComponent } from './shared/templates/change-log-template/change-log-template.component';
import { LoginComponent } from './authentication/Login/Login.component';
import { JsonTreeViewerComponent } from '@product/shared/layout/json-tree-viewer/json-tree-viewer.component';
import { HomeComponent } from './home/home.component';
import { AppConfigService } from './shared/services/app-config.service';
import { BaseAuthComponent } from './authentication/base-auth/base-auth.component';
import { ResetPassComponent } from './authentication/reset-pass/reset-pass.component';
import { NavigationSiderComponent } from './shared/templates/navigation-sider/navigation-sider.component';
import { ManagementModule } from './management/management.module';
import { RegisterUserComponent } from './authentication/register-user/register-user.component';
import { UserProfileComponent } from './authentication/user-profile/user-profile.component';
import { AIService } from './shared/services/AI.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { BulkEditComponent } from './bulk-edit/bulk-edit.component';
import { AttributeSetsComponent } from './forms/attribute/attribute-sets/attribute-sets.component';
import { ProductCatalogComponent } from './product-catalog/ProductCatalog/ProductCatalog.component';
import { CatalogListComponent } from './product-catalog/catalog-list/catalog-list.component';
import { CatalogCardsComponent } from './product-catalog/catalog-cards/catalog-cards.component';
import { NzSpaceModule } from 'ng-zorro-antd/space';



import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ProductDetailsComponent } from './product-catalog/product-details/product-details.component';
import { CatalogProductModule } from './product-catalog/catalog-product.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import {
//   RECAPTCHA_V3_SITE_KEY,
//   ReCaptchaV3Service,
//   RecaptchaModule,
//   RecaptchaV3Module,
// } from 'ng-recaptcha';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    ChangeLogTemplateComponent,
    CategoryComponent,
    JsonTreeViewerComponent,
    LoginComponent,
    BaseAuthComponent,
    ResetPassComponent,
    BulkEditComponent,
    AttributeSetsComponent,
    HomeComponent,
    NavigationSiderComponent,
    RegisterUserComponent,
    UserProfileComponent,

    
  ],
  imports: [
    LayoutModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    SharedModule,
    ManagementModule,
    CatalogProductModule,
    

    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzSpaceModule,
    NzToolTipModule,
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    // ReCaptchaV3Service,
    {
      provide: NZ_I18N,
      useValue: en_US,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestHandlerInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfig: AppConfigService) => {
        return () => appConfig.load();
      },
      deps: [AppConfigService],
      multi: true,
    },
    // {
    //   provide: RECAPTCHA_V3_SITE_KEY,
    //   useFactory: (appconfig: AppConfigService) => {
    //     return () => appconfig.getRecaptchaKey();
    //   },
    // },
    AIService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
